
// import React, { useEffect, useState } from 'react';

// import data from '../../femcare-content.json';
// import { useNavigate } from 'react-router-dom';

// const { keyServices } = data.sections;
// const VISIBLE_COUNT = 4;
// export const serviceImages = {
//   "Physician Consultation": "/images/physicianConsultation.webp",
  
//   "General Endocrinologist Consultation": "/images/endocronology.webp",
//   "General obstetrician Consultation": "/images/obestrics.webp",
//   "General Consultation": "/images/generalPhysician.webp",
// };
// // ── Main component ─────────────────────────────────────────────────────
// const KeyServices = () => {
//   const { id, heading, backgroundImage, items } = keyServices;
//    const [services, setServices] = useState([]);
//    const navigate= useNavigate();
//    const orgId=`6a3ba96dc8e05c65af7f0ef0`

//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const res = await fetch(
//           "https://api.avexa.net/clinic-onboarding/clinics/6a3ba96dc8e05c65af7f0ef0/services"
//         );

//         if (!res.ok) throw new Error("Failed to fetch services");

//         const data = await res.json();
//         console.log(data,"this is the data")
//         setServices(data);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchServices();
//   }, []);
//   // const visibleItems = services.slice(0, VISIBLE_COUNT);
// // const visibleItems = services.slice(0, VISIBLE_COUNT).map((service) => ({
// //   ...service,
// //   image:
// //     serviceImages[service.serviceName] ||
// //     "/images/default.jpg",
// // }));
//   const visibleItems=services.filter(s=>s.status!=="INACTIVE").map((service)=>({
//     ...service,
//     image:service.logoUrl?`https://api.avexa.net/clinic-onboarding/clinics/${orgId}/services/logo?objectKey=${encodeURIComponent(service.logoUrl)}`
//        : serviceImages[service.serviceName] || "/images/default.jpg",
//   })).slice(0,4)
// // console.log(visibleItems,"cvvvvvvvvvvvvvvvvvvvvvvvv")
//   return (
//     <section id={id} className="w-full" style={{ backgroundColor: 'var(--gray-100)' }}>

//       {/* ── Banner ──────────────────────────────────── */}
//       <div
//         className="relative w-full overflow-hidden"
//         style={{ height: 'clamp(170px, 20vw, 260px)' }}
//       >
//         <img
//           src={backgroundImage}
//           alt="Women's healthcare background"
//           className="absolute inset-0 w-full h-full object-cover object-center"
//           draggable={false}
//         />
//         <div className="absolute inset-0" style={{ backgroundColor: 'var(--primary-color)', opacity: 0.52 }} />
//         <div className="relative z-10 h-full flex items-center justify-center px-6 text-center">
//           <h2
//             className="text-white ava-heading-lg"
//             style={{ maxWidth: '800px' }}
//           >
//             {heading}
//           </h2>
//         </div>
//       </div>

//       {/* ── Cards container ─────────────────────────── */}
//       {/*
//         KEY FIX: negative marginTop pulls cards over the banner.
//         The value must be smaller than (banner height / 2) so the
//         heading text is never fully covered.
//         We cap it at -70px max so heading remains visible at all sizes.
//       */}
//       <div
//         className="container mx-auto px-4 md:px-8 pb-10 md:pb-14"
//         style={{ marginTop: 'clamp(-70px, -8vw, -50px)' }}
//       >
//         {/* Static grid, no carousel — 1 col on mobile, 2 on tablet, 4 on desktop */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 ava-card-gap items-stretch">
//           {visibleItems.map((item) => (
//             <ServiceCard key={item.id} item={item} 
//             enableBookNowButton={true}/>
//           ))}
//         </div>
//         <div className='flex justify-center mt-5'>
//         {/* <button className='btn-primary ' onClick={()=>navigate('/services')}>Explore Services</button> */}
//         </div>

//       </div>

//       <div>
//       </div>
//     </section>
//   );
// };

// export const ServiceCard = ({ item,  enableBookNowButton = false, }) =>{
// const navigate=useNavigate()

// return (
//   <div
//     aria-label={item.title}
//     className="flex flex-col bg-white ava-radius-md overflow-hidden shadow-md"
//     style={{ zIndex: "10", height: "100%" }}
//   >
//     <img
//       src={item.image}
//       alt={item.title}
//       className="w-full block"
//       style={{ height: 'clamp(190px, 9vw, 120px)', objectFit: 'cover', objectPosition: 'center top' }}
//       draggable={false}
//     />
//     {/* ✅ flex-1 makes this div grow to fill remaining card height */}
//     <div className="px-3 pt-3 pb-4 md:px-4 flex flex-col gap-1 flex-1">
//       <h3 className="ava-text-subheading">
//         {item.serviceName}
//       </h3>
//       <p className="ava-text-body 
    
//       ">
//         {/*   line-clamp-2 */}
//         {item.description}
//       </p>
//       <div className="mt-2 space-y-3">
//         <div className="flex items-center text-sm text-gray-600">
//           ⏱<span className="ml-2 ava-text-sm">{item.duration} mins</span>
//         </div>
//         <div className="flex items-center text-sm text-gray-600">
//           🏥<span className="ml-2 ava-text-sm line-clamp-1">{item.consultationModes.map(mode=>mode.name).filter(Boolean).join(',') || "In Person"}</span>
//         </div>
//       </div>

//       <div className="mt-2 ava-text-subheading">₹{item.price}</div>

//       {/* ✅ mt-auto now works because the parent flex-col has room to push against */}
//       {enableBookNowButton && (
//       <div className="mt-auto pt-6 flex ">
//         <button className="btn-primary"
//         onClick={()=>navigate('/book-appointment')}
//         >Book Now</button>
//       </div>
//     )}
//     </div>
//   </div>
// );
// }
// export default KeyServices;

import React, { useEffect, useState } from 'react';
import data from '../../femcare-content.json';
import { useNavigate } from 'react-router-dom';

const { keyServices } = data.sections;
const VISIBLE_COUNT = 4;
export const serviceImages = {
  "Physician Consultation": "/images/physicianConsultation.webp",
  "General Endocrinologist Consultation": "/images/endocronology.webp",
  "General obstetrician Consultation": "/images/obestrics.webp",
  "General Consultation": "/images/generalPhysician.webp",
};

// Generic fallback list shown under "Consultation includes" when the API
// doesn't send one for a given service.
const DEFAULT_INCLUSIONS = [
  { label: "Symptom Assessment", icon: "user" },
  { label: "Medical History Review", icon: "doc" },
  { label: "Prescription (if required)", icon: "rx" },
  { label: "Lifestyle Guidance", icon: "heart" },
];

// ── Main component ─────────────────────────────────────────────────────
const KeyServices = () => {
  const { id, heading, backgroundImage, items } = keyServices;
  const [services, setServices] = useState([]);
  const navigate = useNavigate();
  const orgId = `6a3ba96dc8e05c65af7f0ef0`;

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await fetch(
          "https://api.avexa.net/clinic-onboarding/clinics/6a3ba96dc8e05c65af7f0ef0/services"
        );

        if (!res.ok) throw new Error("Failed to fetch services");

        const data = await res.json();
        setServices(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchServices();
  }, []);

  const visibleItems = services
    .filter((s) => s.status !== "INACTIVE")
    .map((service) => ({
      ...service,
      image: service.logoUrl
        ? `https://api.avexa.net/clinic-onboarding/clinics/${orgId}/services/logo?objectKey=${encodeURIComponent(
            service.logoUrl
          )}`
        : serviceImages[service.serviceName] || "/images/default.jpg",
    }))
    .slice(0, 4);

  return (
    <section id={id} className="w-full" style={{ backgroundColor: 'var(--gray-100)' }}>

      {/* ── Banner ──────────────────────────────────── */}
      <div
        className="relative w-full overflow-hidden"
        style={{ height: 'clamp(170px, 20vw, 260px)' }}
      >
        <img
          src={backgroundImage}
          alt="Women's healthcare background"
          className="absolute inset-0 w-full h-full object-cover object-center"
          draggable={false}
        />
        <div className="absolute inset-0" style={{ backgroundColor: 'var(--primary-color)', opacity: 0.52 }} />
        <div className="relative z-10 h-full flex items-center justify-center px-6 text-center">
          <h2 className="text-white ava-heading-lg" style={{ maxWidth: '800px' }}>
            {heading}
          </h2>
        </div>
      </div>

      {/* ── Cards container ─────────────────────────── */}
      <div
        className="container mx-auto px-4 md:px-8 pb-10 md:pb-14"
        style={{ marginTop: 'clamp(-70px, -8vw, -50px)' }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 ava-card-gap items-stretch">
          {visibleItems.map((item) => (
            <ServiceCard key={item.id} item={item} enableBookNowButton={true} />
          ))}
        </div>
      </div>
    </section>
  );
};

// ── Small inline icons (keeps this file dependency-free) ──────────────
const Icon = ({ name, className = "" }) => {
  const common = { width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", className };
  switch (name) {
    case "info":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="9" />
          <line x1="12" y1="11" x2="12" y2="16" />
          <circle cx="12" cy="8" r="0.5" fill="currentColor" />
        </svg>
      );
    case "heart":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <path d="M12 20s-7-4.35-9.33-8.86C1.2 8 2.6 4.5 6 4.5c2 0 3.4 1.2 6 3.6 2.6-2.4 4-3.6 6-3.6 3.4 0 4.8 3.5 3.33 6.64C19 15.65 12 20 12 20z" />
        </svg>
      );
    case "clipboard":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <rect x="5" y="4" width="14" height="17" rx="2" />
          <path d="M9 4V3a1 1 0 011-1h4a1 1 0 011 1v1" />
          <line x1="9" y1="10" x2="15" y2="10" />
          <line x1="9" y1="14" x2="15" y2="14" />
        </svg>
      );
    case "user":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="8" r="3.5" />
          <path d="M5 20c1.2-3.5 4-5 7-5s5.8 1.5 7 5" />
        </svg>
      );
    case "doc":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <path d="M7 3h7l4 4v14H7z" />
          <line x1="10" y1="12" x2="15" y2="12" />
          <line x1="10" y1="16" x2="15" y2="16" />
        </svg>
      );
    case "rx":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <path d="M6 3v18M6 3h6a4 4 0 010 8H6M12 11l7 10" />
        </svg>
      );
    case "close":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <line x1="5" y1="5" x2="19" y2="19" />
          <line x1="19" y1="5" x2="5" y2="19" />
        </svg>
      );
    case "clock":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      );
    case "pin":
      return (
        <svg {...common} stroke="currentColor" strokeWidth="2">
          <path d="M12 21s7-6.2 7-11.5A7 7 0 105 9.5C5 14.8 12 21 12 21z" />
          <circle cx="12" cy="9.5" r="2.3" />
        </svg>
      );
    case "star":
      return (
        <svg {...common} fill="currentColor">
          <path d="M12 2l2.9 6.3 6.9.9-5 4.8 1.3 6.9L12 17.8 5.9 20.9l1.3-6.9-5-4.8 6.9-.9z" />
        </svg>
      );
    default:
      return null;
  }
};

// ── Service card + popup ────────────────────────────────────────────────
export const ServiceCard = ({ item, enableBookNowButton = false }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const consultationModeText =
    item.consultationModes?.map((m) => m.name).filter(Boolean).join(', ') || "In Person";

  // API sends conditionFocuses as [{ id, name }] — pull out just the names.
  const conditions = item.conditionFocuses?.length
    ? item.conditionFocuses.map((c) => c.name).filter(Boolean)
    : null;
  const inclusions = item.inclusions?.length
    ? item.inclusions.map((label) => ({ label, icon: "clipboard" }))
    : DEFAULT_INCLUSIONS;
    const handleBookNow = (specialityId) => {
  navigate(`/book-appointment?specialityId=${specialityId}`);
};

  return (
    <>
      <div
        aria-label={item.title}
        className="flex flex-col bg-white ava-radius-md overflow-hidden shadow-md"
        style={{ zIndex: "10", height: "100%" }}
      >
        <img
          src={item.image}
          alt={item.title}
          className="w-full block"
          style={{ height: 'clamp(190px, 9vw, 120px)', objectFit: 'cover', objectPosition: 'center top' }}
          draggable={false}
        />
        <div className="px-3 pt-3 pb-4 md:px-4 flex flex-col gap-1 flex-1">
          <h3 className="ava-text-subheading  line-clamp-1">{item.serviceName}</h3>
          <p className="ava-text-body  line-clamp-2">{item.description}</p>
          <div className="mt-2 space-y-3">
            <div className="flex items-center text-sm text-gray-600">
              ⏱<span className="ml-2 ava-text-sm">{item.duration} mins</span>
            </div>
            <div className="flex items-center text-sm text-gray-600">
              🏥<span className="ml-2 ava-text-sm line-clamp-1">{consultationModeText}</span>
            </div>
          </div>

          <div className="mt-2 ava-text-subheading">₹{item.price}</div>

          <div className="mt-auto pt-6 flex gap-2 flex-row justify-between">
            <button
              // className="ava-radius-md py-2 text-sm font-semibold border"
              className='btn-transparent'
              style={{ borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }}
              onClick={() => setIsOpen(true)}
            >
              View Details
            </button>
            {enableBookNowButton && (
              <button className="btn-primary"
              //  onClick={() => navigate('/book-appointment')}
              onClick={()=>handleBookNow(item.specialityId)}
               >
                Book Now
              </button>
            )}
          </div>
        </div>
      </div>

      {isOpen && (
        <ServiceDetailsModal
          item={item}
          consultationModeText={consultationModeText}
          conditions={conditions}
          inclusions={inclusions}
          onClose={() => setIsOpen(false)}
          onBook={() => {
            setIsOpen(false);
            navigate(`/book-appointment?specialityId=${item?.specialityId}`);
          }}
        />
      )}
    </>
  );
};

  // const ServiceDetailsModal = ({ item, consultationModeText, conditions, inclusions, onClose, onBook }) => {
  //   useEffect(() => {
  //     const onKey = (e) => e.key === "Escape" && onClose();
  //     document.addEventListener("keydown", onKey);
  //     document.body.style.overflow = "hidden";
  //     return () => {
  //       document.removeEventListener("keydown", onKey);
  //       document.body.style.overflow = "";
  //     };
  //   }, [onClose]);

  //   return (
  //     <div
  //       className="fixed inset-0 z-50 flex items-center justify-center p-4"
  //       style={{ backgroundColor: 'rgba(15, 15, 20, 0.55)' }}
  //       onClick={onClose}
  //     >
  //       <div
  //         className="bg-white ava-radius-md shadow-xl w-full overflow-hidden flex flex-col"
  //         style={{ maxWidth: '800px', maxHeight: '90vh' }}
  //         onClick={(e) => e.stopPropagation()}
  //       >
  //         <div className="flex flex-col md:flex-row overflow-y-auto">
  //           {/* ── Left: compact card preview ───────────────────────── */}
  //           <div
  //             className="w-full md:w-[320px] flex-shrink-0 p-5"
  //             style={{ backgroundColor: 'var(--gray-100)' }}
  //           >
  //             <div className="relative ava-radius-md overflow-hidden mb-4">
  //               <img
  //                 src={item.image}
  //                 alt={item.serviceName}
  //                 className="w-full object-cover"
  //                 style={{ height: '220px' }}
  //                 draggable={false}
  //               />
  //               {item.rating && (
  //                 <span
  //                   className="absolute left-3 bottom-3 flex items-center gap-1 px-2 py-1 rounded-full text-white text-xs font-semibold"
  //                   style={{ backgroundColor: 'var(--primary-color)' }}
  //                 >
  //                   <Icon name="star" className="w-3 h-3" />
  //                   {item.rating}
  //                 </span>
  //               )}
  //             </div>

  //             <h3 className="ava-text-subheading mb-2">{item.serviceName}</h3>
  //             <p className="ava-text-body mb-4">{item.description}</p>

  //             <div className="border-t pt-3 space-y-3">
  //               <div className="flex items-center gap-3">
  //                 <Icon name="clock" className="opacity-60" />
  //                 <div>
  //                   <div className="text-xs text-gray-500">Duration</div>
  //                   <div className="ava-text-sm font-semibold">{item.duration} mins</div>
  //                 </div>
  //               </div>
  //               <div className="flex items-center gap-3">
  //                 <Icon name="pin" className="opacity-60" />
  //                 <div>
  //                   <div className="text-xs text-gray-500">Consultation Mode</div>
  //                   <div className="ava-text-sm font-semibold">{consultationModeText}</div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           {/* ── Right: details panel ─────────────────────────────── */}
  //           <div className="flex-1 p-6 md:p-8 relative">
  //             <button
  //               onClick={onClose}
  //               className="absolute top-5 right-5 text-gray-400 hover:text-gray-600"
  //               aria-label="Close"
  //             >
  //               <Icon name="close" />
  //             </button>

  //             <section className="mb-6">
  //               <div className="flex items-center gap-2 mb-3">
  //                 <Icon name="info" style={{ color: 'var(--primary-color)' }} className="opacity-90" />
  //                 <h4 className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>
  //                   About this service
  //                 </h4>
  //               </div>
  //               <p className="ava-text-body">{item.description}</p>
  //             </section>

  //             {conditions && (
  //               <>
  //                 <hr className="my-5" />
  //                 <section className="mb-6">
  //                   <div className="flex items-center gap-2 mb-3">
  //                     <Icon name="heart" style={{ color: 'var(--primary-color)' }} />
  //                     <h4 className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>
  //                       Conditions we treat
  //                     </h4>
  //                   </div>
  //                   <div className="flex flex-wrap gap-2">
  //                     {conditions.map((c) => (
  //                       <span
  //                         key={c}
  //                         className="px-3 py-1 rounded-full text-sm"
  //                         style={{ backgroundColor: 'var(--primary-color-10, #F3EAFB)', color: 'var(--primary-color)' }}
  //                       >
  //                         {c}
  //                       </span>
  //                     ))}
  //                   </div>
  //                 </section>
  //               </>
  //             )}

  //             <hr className="my-5" />
  //             <section>
  //               <div className="flex items-center gap-2 mb-4">
  //                 <Icon name="clipboard" style={{ color: 'var(--primary-color)' }} />
  //                 <h4 className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>
  //                   Consultation includes
  //                 </h4>
  //               </div>
  //               <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
  //                 {inclusions.map((inc) => (
  //                   <div key={inc.label} className="flex flex-col items-center text-center gap-2">
  //                     <div
  //                       className="w-12 h-12 rounded-full flex items-center justify-center"
  //                       style={{ backgroundColor: 'var(--primary-color-10, #F3EAFB)' }}
  //                     >
  //                       <Icon name={inc.icon} style={{ color: 'var(--primary-color)' }} />
  //                     </div>
  //                     <span className="ava-text-xs font-medium">{inc.label}</span>
  //                   </div>
  //                 ))}
  //               </div>
  //             </section>
  //           </div>
  //         </div>

  //         {/* ── Footer ──────────────────────────────────────────────── */}
  //         <div className="flex items-center justify-between px-6 md:px-8 py-4 border-t bg-white">
  //           <div>
  //             <div className="text-xs text-gray-500">Consultation Fee</div>
  //             <div className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>
  //               ₹{item.price}
  //             </div>
  //           </div>
  //           <button className="btn-primary px-6" onClick={onBook}>
  //             Book Appointment
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };
  const ServiceDetailsModal = ({ item, consultationModeText, conditions, inclusions, onClose, onBook }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(15, 15, 20, 0.55)' }}
      onClick={onClose}
    >
      <div
        className="bg-white ava-radius-md shadow-xl w-full overflow-hidden flex flex-col"
        style={{ maxWidth: '800px', maxHeight: '90vh' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col md:flex-row overflow-y-auto">
          {/* ── Left: compact card preview ───────────────────────── */}
          <div
            className="w-full md:w-[320px] flex-shrink-0 p-5"
            style={{ backgroundColor: 'var(--gray-100)' }}
          >
            <div className="relative ava-radius-md overflow-hidden mb-4">
              <img
                src={item.image}
                alt={item.serviceName}
                className="w-full object-cover"
                style={{ height: '220px' }}
                draggable={false}
              />
              {item.rating && (
                <span
                  className="absolute left-3 bottom-3 flex items-center gap-1 px-2 py-1 rounded-full text-white text-xs font-semibold"
                  style={{ backgroundColor: 'var(--primary-color)' }}
                >
                  <Icon name="star" className="w-3 h-3" />
                  {item.rating}
                </span>
              )}
            </div>

            <h3 className="ava-text-subheading mb-2">{item.serviceName}</h3>
            <p className="ava-text-body mb-4">{item.description}</p>

            <div className="border-t pt-3 space-y-3">
              <div className="flex items-center gap-3">
                <Icon name="clock" className="opacity-60" />
                <div>
                  <div className="text-xs text-gray-500">Duration</div>
                  <div className="ava-text-sm font-semibold">{item.duration} mins</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Icon name="pin" className="opacity-60" />
                <div>
                  <div className="text-xs text-gray-500">Consultation Mode</div>
                  <div className="ava-text-sm font-semibold">{consultationModeText}</div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Right: details panel ─────────────────────────────── */}
          <div className="flex-1 flex flex-col p-6 md:p-8 relative">
            <button
              onClick={onClose}
              className="absolute top-5 right-5 text-gray-400 hover:text-gray-600"
              aria-label="Close"
            >
              <Icon name="close" />
            </button>

            {/* top block: About + Conditions */}
            <div>
              <section className="mb-6">
                <div className="flex items-center gap-2 mb-3">
                  <Icon name="info" style={{ color: 'var(--primary-color)' }} className="opacity-90" />
                  <h4 className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>
                    About this service
                  </h4>
                </div>
                <p className="ava-text-body">{item.description}</p>
              </section>

              {conditions && (
                <>
                  <hr className="my-5" />
                  <section>
                    <div className="flex items-center gap-2 mb-3">
                      <Icon name="heart" style={{ color: 'var(--primary-color)' }} />
                      <h4 className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>
                        Conditions we treat
                      </h4>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {conditions.map((c) => (
                        <span
                          key={c}
                          className="px-3 py-1 rounded-full text-sm"
                          style={{ backgroundColor: 'var(--primary-color-10, #F3EAFB)', color: 'var(--primary-color)' }}
                        >
                          {c}
                        </span>
                      ))}
                    </div>
                  </section>
                </>
              )}
            </div>

            {/* bottom block: Consultation includes — always pinned to the bottom of the panel */}
            <div className="mt-auto">
              <hr className="my-5" />
              <section>
                <div className="flex items-center gap-2 mb-4">
                  <Icon name="clipboard" style={{ color: 'var(--primary-color)' }} />
                  <h4 className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>
                    Consultation includes
                  </h4>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {inclusions.map((inc) => (
                    <div key={inc.label} className="flex flex-col items-center text-center gap-2">
                      <div
                        className="w-10 h-10 rounded-full flex items-center justify-center"
                        style={{ backgroundColor: 'var(--primary-color-10, #F3EAFB)' }}
                      >
                        <Icon name={inc.icon} style={{ color: 'var(--primary-color)' }} />
                      </div>
                      <span className="ava-text-xs font-medium">{inc.label}</span>
                    </div>
                  ))}
                </div>
              </section>
            </div>
          </div>
        </div>

        {/* ── Footer ──────────────────────────────────────────────── */}
        <div className="flex items-center justify-between px-6 md:px-8 py-4 border-t bg-white">
          <div>
            <div className="text-xs text-gray-500">Consultation Fee</div>
            <div className="ava-text-subheading" style={{ color: 'var(--primary-color)' }}>
              ₹{item.price}
            </div>
          </div>
          <button className="btn-primary px-6" onClick={onBook}>
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default KeyServices;